<template>
  <dx-modal :value="show" title="Atualizar preços e repasse" size="lg"
            class="gd-scope gd-reprice-modal" id="modal-billing-guide-reprice"
            :closable="!applying" @input="close()">
    <div class="stenci-group stenci-alert gd-reprice-note">
      Os valores passam a seguir a tabela, o plano e a regra de repasse vigentes agora.
      Confira o de/para antes de aplicar; a alteração fica registrada no histórico da guia.
    </div>

    <div class="cr-summary">
      <div class="cr-summary-item cr-summary-scope">
        <small>Itens que mudam</small>
        <div class="cr-summary-value">{{ preview.changed }} de {{ preview.items.length }}</div>
        <span class="cr-summary-hint" v-if="guideNumber">guia nº {{ guideNumber }}</span>
      </div>
      <div class="cr-summary-item soft">
        <small>Convênio</small>
        <div class="cr-summary-value">{{ preview.after.insurance | currency }}</div>
        <span class="cr-summary-hint">antes {{ preview.before.insurance | currency }}</span>
      </div>
      <div class="cr-summary-item">
        <small>Diferença no convênio</small>
        <div class="cr-summary-value" :class="diffClass(preview.diff.insurance)">
          {{ signed(preview.diff.insurance) }}
        </div>
      </div>
      <div class="cr-summary-item soft">
        <small>Repasse</small>
        <div class="cr-summary-value">{{ preview.after.transfer | currency }}</div>
        <span class="cr-summary-hint">antes {{ preview.before.transfer | currency }}</span>
      </div>
      <div class="cr-summary-item">
        <small>Diferença no repasse</small>
        <div class="cr-summary-value" :class="diffClass(preview.diff.transfer)">
          {{ signed(preview.diff.transfer) }}
        </div>
      </div>
    </div>

    <div class="cr-panel">
      <div class="cr-panel-head">
        <div class="cr-panel-title">
          <fa-icon :icon="['fal', 'list']" class="cr-panel-icon"/>
          De / para por item
          <span class="label label-rounded">{{ preview.changed }}</span>
        </div>
        <div class="cr-panel-subtitle">
          Valor do convênio e repasse do profissional · os itens sem alteração ficam como estão
        </div>
      </div>
      <div class="cr-table-scroll">
        <table class="table gd-reprice-table">
          <thead>
          <tr>
            <th>Serviço</th>
            <th class="text-center" style="width: 60px">Qtde</th>
            <th class="text-right" style="width: 100px">Convênio antes</th>
            <th class="text-right" style="width: 100px">Convênio depois</th>
            <th class="text-right" style="width: 100px">Diferença</th>
            <th class="text-right" style="width: 100px">Repasse antes</th>
            <th class="text-right" style="width: 100px">Repasse depois</th>
            <th class="text-right" style="width: 100px">Diferença</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item, index) in preview.items" :key="item.id || index"
              :class="{unchanged: !item.changed}">
            <td>
              <span class="name">{{ item.expense.name }}</span>
              <span class="gd-sub">
                {{ item.expense.code | tuss }}
                <template v-if="item.professionalName"> · {{ item.professionalName }}</template>
                <template v-if="!item.changed"> · sem alteração</template>
                <template v-if="copayText(item)"> · {{ copayText(item) }}</template>
              </span>
            </td>
            <td class="text-center gd-num">{{ item.quantity }}</td>
            <td class="text-right gd-num">{{ item.before.insurance | currency }}</td>
            <td class="text-right gd-val">{{ item.after.insurance | currency }}</td>
            <td class="text-right gd-val" :class="diffClass(item.diff.insurance)">
              {{ signed(item.diff.insurance) }}
            </td>
            <td class="text-right gd-num">{{ item.before.transfer | currency }}</td>
            <td class="text-right gd-val">{{ item.after.transfer | currency }}</td>
            <td class="text-right gd-val" :class="diffClass(item.diff.transfer)">
              {{ signed(item.diff.transfer) }}
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>

    <template slot="footer">
      <button class="btn btn-primary btn-icon btn-icon-left mr-1"
              :class="{loading: applying}" :disabled="applying" @click="$emit('confirm')">
        <fa-icon :icon="['fal', 'sync']"/>Atualizar preços e repasse
      </button>
      <button class="btn" :disabled="applying" @click="close()">Voltar</button>
    </template>
  </dx-modal>
</template>

<script>
import currency from '@/filters/currency';

export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    preview: {
      type: Object,
      required: true,
    },
    applying: {
      type: Boolean,
      default: false,
    },
    guideNumber: {
      type: String,
      default: null,
    },
  },
  methods: {
    signed(value) {
      const amount = Number(value) || 0;
      if (amount === 0) return '—';
      return `${amount > 0 ? '+' : '-'} ${currency(Math.abs(amount))}`;
    },
    diffClass(value) {
      const amount = Number(value) || 0;
      return {
        'gd-up': amount > 0,
        'gd-down': amount < 0,
        'gd-muted': amount === 0,
      };
    },
    copayText(item) {
      if (!item.diff.particular) return '';
      return `paciente ${currency(item.before.particular)} → ${currency(item.after.particular)}`;
    },
    close() {
      if (this.applying) return;
      this.$emit('close');
    },
  },
};
</script>
